export class ItiMenuItem {
    public icon!: string;
    public text!: string;
    public i18n!: string;
    public link?: string;
    public href?: string;
    public target?: string;
    public img?: string;
    public tooltipi18n?: string;
    public permission!: string | string[];
    public children: ItiMenuItem[] = [];
    
}
